import { useCallback, useEffect, useState, useContext } from "react";
import { FilterContext } from "../FilterContextProvider";
import useApi from "../Api/Api";

const useAllEvents = (
  filterOverrides = {},
  vendorFilter = {},
  indexType = false,
  ctmTaxable = false
) => {
  const { filterData } = useContext(FilterContext);
  const api = useApi();
  const [allEvents, setAllEvents] = useState([]);
  const [checkSentFilter, setCheckSentFilter] = useState();
  const [checkReceivedFilter, setCheckReceivedFilter] = useState();
  const [allEventsSearch, setAllEventsSearch] = useState();
  const [allEventsSort, setAllEventsSort] = useState("date");
  const [allEventDates, setAllEventDates] = useState({
    startDate: "",
    endDate: "",
  });

  const getAllEvents = useCallback(() => {
    let type = "all";
    let queryParams = {};
    if (filterData.artist_id && !indexType) {
      queryParams.artist_id = filterData.artist_id;
    }
    if(ctmTaxable === true){
      queryParams.ctm_tax_responsible = true;
    }
    if (allEventDates.startDate) {
      queryParams.start_date = allEventDates.startDate;
    }
    if (checkSentFilter != null) {
      queryParams.check_sent = checkSentFilter;
    }
    if (checkReceivedFilter != null) {
      queryParams.check_received = checkReceivedFilter;
    }
    if (allEventDates.endDate) {
      queryParams.end_date = allEventDates.endDate;
    }
    if (allEventsSearch) {
      queryParams.query = allEventsSearch;
    }
    if (allEventsSort) {
      queryParams.sort = allEventsSort;
    }
    if (filterOverrides) {
      queryParams.reporting_type = filterOverrides;
    }
    if (vendorFilter) {
      queryParams.vendor = vendorFilter;
    }
    if (indexType) {
      type = indexType;
    } else {
      type = "all";
    }
    const queryString = Object.keys(queryParams)
      .map((param) => `${param}=${queryParams[param]}`)
      .join("&");
    filterData.artist_id &&
      api.get(`/events/${type}?${queryString}`).then((r) => {
        setAllEvents(r.data);
      });
  }, [
    api,
    filterData,
    allEventDates,
    allEventsSearch,
    allEventsSort,
    ctmTaxable,
    checkSentFilter,
    checkReceivedFilter,
    filterOverrides,
    vendorFilter,
    indexType,
  ]);

  useEffect(() => {
    setAllEvents([]);
  }, [filterData]);

  useEffect(() => {
    getAllEvents();
  }, [getAllEvents]);

  allEvents.forEach((event) => {
    const [year, month, day] = event.date.split("T")[0].split("-");
    event.formattedDate = `${month}/${day}/${year}`;
  });

  const allEventDateOptions = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "This month", value: "this_month" },
    { label: "Last month", value: "last_month" },
    { label: "This year", value: "this_year" },
    { label: "Last year", value: "last_year" },
    { label: "First quarter", value: "first_quarter" },
    { label: "Second quarter", value: "second_quarter" },
    { label: "Third quarter", value: "third_quarter" },
    { label: "Fourth quarter", value: "fourth_quarter" },
    { label: "All time", value: "all_time" },
    { label: "Custom", value: "custom" },
  ];

  const date = new Date().toISOString().slice(0, 10);
  const day = new Date().toISOString().slice(8, 10);
  const month = new Date().toISOString().slice(5, 7);
  const year = new Date().toISOString().slice(0, 4);

  const handleAllEventDateSelect = (e) => {
    switch (e.target?.id || e.value) {
      case "today":
        return setAllEventDates({
          dateButton: "today",
          startDate: date,
          endDate: date,
        });
      case "yesterday":
        if (day === "01") {
          if (month === "01") {
            return setAllEventDates({
              dateButton: "yesterday",
              startDate: `${year - 1}-12-31`,
              endDate: `${year - 1}-12-31`,
            });
          } else if (
            month === "02" ||
            month === "04" ||
            month === "06" ||
            month === "08" ||
            month === "09"
          ) {
            return setAllEventDates({
              dateButton: "yesterday",
              startDate: `${year}-0${month - 1}-31`,
              endDate: `${year}-0${month - 1}-31`,
            });
          } else if (month === "11") {
            return setAllEventDates({
              dateButton: "yesterday",
              startDate: `${year}-${month - 1}-31`,
              endDate: `${year}-${month - 1}-31`,
            });
          } else if (month === "05" || month === "07" || month === "10") {
            return setAllEventDates({
              dateButton: "yesterday",
              startDate: `${year}-0${month - 1}-30`,
              endDate: `${year}-0${month - 1}-30`,
            });
          } else if (month === "12") {
            return setAllEventDates({
              dateButton: "yesterday",
              startDate: `${year}-${month - 1}-30`,
              endDate: `${year}-${month - 1}-30`,
            });
          } else if (month === "03" && year % 4 === 0) {
            return setAllEventDates({
              dateButton: "yesterday",
              startDate: `${year}-02-29`,
              endDate: `${year}-02-29`,
            });
          } else if (month === "03" && year % 4 !== 0) {
            return setAllEventDates({
              dateButton: "yesterday",
              startDate: `${year}-02-28`,
              endDate: `${year}-02-28`,
            });
          }
        } else {
          return setAllEventDates({
            dateButton: "yesterday",
            startDate: `${year}-${month}-${day - 1}`,
            endDate: `${year}-${month}-${day - 1}`,
          });
        }
        break;
      case "this_month":
        if (
          month === "01" ||
          month === "03" ||
          month === "05" ||
          month === "07" ||
          month === "08" ||
          month === "10" ||
          month === "12"
        ) {
          return setAllEventDates({
            dateButton: "this_month",
            startDate: `${year}-${month}-01`,
            endDate: `${year}-${month}-31`,
          });
        } else if (
          month === "04" ||
          month === "06" ||
          month === "09" ||
          month === "11"
        ) {
          return setAllEventDates({
            dateButton: "this_month",
            startDate: `${year}-${month}-01`,
            endDate: `${year}-${month}-30`,
          });
        } else if (month === "02" && year % 4 === 0) {
          return setAllEventDates({
            dateButton: "this_month",
            startDate: `${year}-02-01`,
            endDate: `${year}-02-29`,
          });
        } else if (month === "02" && year % 4 !== 0) {
          return setAllEventDates({
            dateButton: "this_month",
            startDate: `${year}-02-01`,
            endDate: `${year}-02-28`,
          });
        }
        break;
      case "last_month":
        if (month === "01") {
          return setAllEventDates({
            dateButton: "last_month",
            startDate: `${year - 1}-12-01`,
            endDate: `${year - 1}-12-31`,
          });
        } else if (
          month === "02" ||
          month === "04" ||
          month === "06" ||
          month === "08" ||
          month === "09"
        ) {
          return setAllEventDates({
            dateButton: "last_month",
            startDate: `${year}-0${month - 1}-01`,
            endDate: `${year}-0${month - 1}-31`,
          });
        } else if (month === "11") {
          return setAllEventDates({
            dateButton: "last_month",
            startDate: `${year}-${month - 1}-01`,
            endDate: `${year}-${month - 1}-31`,
          });
        } else if (month === "05" || month === "07" || month === "10") {
          return setAllEventDates({
            dateButton: "last_month",
            startDate: `${year}-0${month - 1}-01`,
            endDate: `${year}-0${month - 1}-30`,
          });
        } else if (month === "12") {
          return setAllEventDates({
            dateButton: "last_month",
            startDate: `${year}-${month - 1}-01`,
            endDate: `${year}-${month - 1}-30`,
          });
        } else if (month === "03" && year % 4 === 0) {
          return setAllEventDates({
            dateButton: "last_month",
            startDate: `${year}-02-01`,
            endDate: `${year}-02-29`,
          });
        } else if (month === "03" && year % 4 !== 0) {
          return setAllEventDates({
            dateButton: "last_month",
            startDate: `${year}-02-01`,
            endDate: `${year}-02-28`,
          });
        }
        break;
      case "this_year":
        return setAllEventDates({
          dateButton: "this_year",
          startDate: `${year}-01-01`,
          endDate: `${year}-12-31`,
        });
      case "last_year":
        return setAllEventDates({
          dateButton: "last_year",
          startDate: `${year - 1}-01-01`,
          endDate: `${year - 1}-12-31`,
        });
      case "first_quarter":
        return setAllEventDates({
          dateButton: "first_quarter",
          startDate: `${year}-01-01`,
          endDate: `${year}-03-31`,
        });
      case "second_quarter":
        return setAllEventDates({
          dateButton: "second_quarter",
          startDate: `${year}-04-01`,
          endDate: `${year}-06-30`,
        });
      case "third_quarter":
        return setAllEventDates({
          dateButton: "third_quarter",
          startDate: `${year}-07-01`,
          endDate: `${year}-09-30`,
        });
      case "fourth_quarter":
        return setAllEventDates({
          dateButton: "fourth_quarter",
          startDate: `${year}-10-01`,
          endDate: `${year}-12-31`,
        });
      case "all_time":
        return setAllEventDates({
          dateButton: "all_time",
          startDate: `1900-01-01`,
          endDate: `2100-12-31`,
        });
      case "custom":
        return setAllEventDates({
          dateButton: "custom",
          startDate: "",
          endDate: "",
        });
      default:
    }
  };

  const handleCustomAllEventStartDate = (e) => {
    allEventDates.dateButton === "custom" &&
      setAllEventDates({
        ...allEventDates,
        startDate: e.target.value,
      });
  };

  const handleCustomAllEventEndDate = (e) => {
    allEventDates.dateButton === "custom" &&
      setAllEventDates({
        ...allEventDates,
        endDate: e.target.value,
      });
  };

  const renderCustomAllEventDateSelector = () => {
    return (
      <div
        className={
          allEventDates.dateButton === "custom"
            ? "flex text-xs text-black"
            : "flex text-xs text-gray-400"
        }
      >
        <div className="flex flex-col w-1/2 mr-2">
          <label htmlFor="startDate">From</label>
          <input
            value={allEventDates.startDate ?? ""}
            disabled={allEventDates.dateButton !== "custom"}
            type="date"
            id="startDate"
            className="h-10 pl-2 rounded-md border"
            onChange={handleCustomAllEventStartDate}
          ></input>
        </div>
        <div className="flex flex-col w-1/2">
          <label htmlFor="endDate">To</label>
          <input
            value={allEventDates.endDate ?? ""}
            disabled={allEventDates.dateButton !== "custom"}
            type="date"
            id="endDate"
            className="h-10 pl-2 rounded-md border"
            onChange={handleCustomAllEventEndDate}
          ></input>
        </div>
      </div>
    );
  };

  return {
    allEvents,
    getAllEvents,
    setAllEventsSearch,
    setAllEventsSort,
    checkSentFilter,
    setCheckSentFilter,
    checkReceivedFilter,
    setCheckReceivedFilter,
    allEventDates,
    allEventDateOptions,
    handleAllEventDateSelect,
    renderCustomAllEventDateSelector,
  };
};

export default useAllEvents;
